<template>
  <div id="MyCourses">
    <h3>我的课程</h3>
    <div class="">
      <Empty v-if="course_o.finished && !course_o.list.length" />
      <Curriculum data_lineLen="5" :data_list="course_o.list" />
    </div>
    <div class="pageMod">
      <a-pagination
              show-less-items
              v-if="course_o.list.length && course_o.totalPage > 1"
              v-model:current="course_o.pageNo"
              :default-current="course_o.defaultCurrent"
              :total="course_o.totalCount"
              :pageSize="course_o.pageSize"
              @change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import Curriculum from "@c/course/Curriculum";
import { Empty,Pagination } from "ant-design-vue";
import { getPcUserCourses } from "@/api";
import { getUserId } from '@/utils/methods.js';
import { pageview } from "../../utils/AnalysysAgent";

export default {
  name: "MyCourses",
  components: {
    Curriculum,
    Empty,
    [Pagination.name]:Pagination,
  },
  data() {
    return {
      userId: getUserId(),
      course_o: {
        list: [],
        pageNo: 1, // 当前页数
        pageSize: 10, // 每页条数
        defaultCurrent: 1, // 默认页数
        totalCount: 0,// 总条数
        totalPage: 0, // 总页数
        finished: false,
      },
    };
  },
  methods: {
    onPageChange(current, pageSize) {
      console.log(current, pageSize);
      this.course_o.current = current;
      this.getCourse();
    },
    getCourse() {
      getPcUserCourses({
        userId: this.userId,
        pageNo: this.course_o.pageNo,
        pageSize: this.course_o.pageSize,
      }).then((res) => {
        console.log("我的课程", res);
        if (res.data.code === 1) {
          this.course_o.list = res.data.list;
          this.course_o.totalCount = res.data.page.totalCount;
          this.course_o.totalPage = res.data.page.totalPage;
          this.course_o.finished = true;
        }
      });
    },
  },
  mounted() {
    pageview(String(this.userId),'',"我的课程",this.$route.fullPath)
    this.getCourse();
  },
};
</script>

<style scoped lang="scss">
#MyCourses {
  @extend %safetyWidth;

  h3{
    font-size: 20px;
    margin-bottom: 20px;
  }
}
.ant-empty {
  margin-top: 100px;
}
  .pageMod{
    text-align: center;
    margin-top: 20px;
  }
</style>
